import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=34eca484&scoped=true&"
import script from "./studentList.vue?vue&type=script&lang=js&"
export * from "./studentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eca484",
  null
  
)

export default component.exports